import { render } from "./HotKeyLegend.vue?vue&type=template&id=7e66fee3&scoped=true"
import script from "./HotKeyLegend.vue?vue&type=script&lang=js"
export * from "./HotKeyLegend.vue?vue&type=script&lang=js"

import "./HotKeyLegend.vue?vue&type=style&index=0&id=7e66fee3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7e66fee3"

export default script